import { Injectable, inject } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { HolidaysGateway } from '../gateway/holidays.gateway';
import {
  loadHolidays,
  loadHolidaysFail,
  loadHolidaysSuccess,
} from '../actions/holidays.actions';
import { map, of, switchMap } from 'rxjs';
import { BoelsReservation } from '@boels/models';
import { catchError } from 'rxjs/operators';

@Injectable({
  providedIn: 'any',
})
export class HolidaysEffect {
  protected actions$ = inject(Actions);
  protected holidaysGateway = inject(HolidaysGateway);

  loadHolidays$ = createEffect(() =>
    this.actions$.pipe(
      ofType(loadHolidays),
      switchMap((value) =>
        this.holidaysGateway
          .getHolidays(value.startDate, value.endDate)
          .pipe(
            map((holidays: BoelsReservation) =>
              loadHolidaysSuccess({ holidays }),
            ),
          ),
      ),
      catchError(() => of(loadHolidaysFail())),
    ),
  );
}
